
    const TEXT_TEMPLATES = {
    apple_warning: `
    <p class='title_warning'>Your Apple devices is compatible! Select your GlocalMe eSIM</p>
    <p><span>*</span>The following Apple devices do not support eSIM functionality:</p>
        <ul>
            <li>iPhone devices purchased in mainland China</li>
            <li>iPhone devices from Hong Kong and Macau (except iPhone 13 mini, iPhone 12 mini, iPhone SE 2020, and iPhone XS)</li>
        </ul>
        <p><span>*</span>For iPhone and iPad purchased in Turkey:</p>
        <ul>
            <li>If your device was set up after June 23, 2020, your eSIM will be activated after installation. If your eSIM is not enabled, please contact your carrier.</li>
            <li><span>For devices set up before June 23, 2020, please follow the steps in the link to activate eSIM.</span> This process may require you to erase your device data, so please make sure to back up your device in advance.</li>

        </ul>
        <p><span>*</span>Only iPad devices with Wi-Fi + Cellular capability are supported.</p>
    `,
    samsung_warning: `
    <p class='title_warning'>Your Samsung devices is compatible! Select your GlocalMe eSIM</p>
    <p><span>*</span>The following Samsung Galaxy devices do not support eSIM functionality:</p>
        <ul>
            <li>All Galaxy devices from China, Hong Kong, and Taiwan.</li>
            <li>All Galaxy FE “Fan Edition” models, except Galaxy S23 FE and S24 FE.</li>
            <li>US models of Galaxy S20, S21<span>*</span>, and Note 20 Ultra.</li>
        </ul>
        <p><span>*</span>Except for Galaxy S24, S23, Z Fold 5, Z Fold 4, Z Flip 5, Z Flip 4, and A54 5G models, most Samsung Galaxy devices purchased in Korea do not support eSIM.</p>
        
        <p><span>*</span>Except for Galaxy S24, S23, Z Fold 5, Z Fold 4, Z Flip 5, Z Flip 4, and A54 5G models, most Samsung Galaxy devices purchased in Korea do not support eSIM.</p>
    `,
    google_warning: `
    <p class='title_warning'>Your Google Pixel devices is compatible! Select your GlocalMe eSIM</p>
    <p><span>*</span>The following Google Pixel devices do not support eSIM functionality:</p>
        <ul>
            <li>Pixel 3 models purchased in Australia, Taiwan, and Japan, as well as models purchased through US or Canadian carriers other than Sprint and Google Fi.</li>
            <li>Pixel 3a models purchased in Southeast Asia and used on Verizon services.</li>
    
        </ul>
    `,
    
    hammer_warning: `
        <p class='title_warning'>Your Hammer devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM support is only available in certain regions. Please contact your carrier or device manufacturer to confirm whether your Hammer device supports eSIM.</p>
    `,
    honor_warning: `
        <p class='title_warning'>Your Honor devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM support is only available in certain regions. Please contact your carrier or device manufacturer to confirm whether your Honor device supports eSIM.</p>
    `,
    huawei_warning: `
    <p class='title_warning'>Your HuaWei devices is compatible! Select your GlocalMe eSIM</p>
    <p><span>*</span>The following Huawei devices do not support eSIM functionality:</p>
        <ul>
            <li>Huawei P40 Pro+</li>
            <li>All Huawei devices purchased in China do not support eSIM.</li>
            
        </ul>
    `,
    motorola_warning: `
        <p class='title_warning'>Your Motorola devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM support is only available in certain regions. Please contact your carrier or device manufacturer to confirm whether your Motorola device supports eSIM.</p>
    `,
    nokia_warning: `
        <p class='title_warning'>Your Nokia devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM availability varies by country/region and carrier. Please contact your carrier or device manufacturer to confirm whether your Nokia device supports eSIM.</p>
    `,
    oneplus_warning: `
        <p class='title_warning'>Your Oneplus devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM support is only available in certain regions. Please contact your carrier or device manufacturer to confirm whether your OnePlus device supports eSIM.</p>
    `,
    oppo_warning: `
        <p class='title_warning'>Your Oppo devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM support is only available in Japan and select regions. Please contact your carrier or device manufacturer to confirm whether your Oppo device supports eSIM.</p>
    `,
    rakuten_warning: `
        <p class='title_warning'>Your Rakuten devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM support is only available in Japan and select regions. Please contact your carrier or device manufacturer to confirm whether your Rakuten device supports eSIM.</p>
    `,
    sharp_warning: `
        <p class='title_warning'>Your Sharp devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM support is only available in Japan and select regions. Please contact your carrier or device manufacturer to confirm whether your Sharp device supports eSIM.</p>
    `,
    sony_warning: `
    <p class='title_warning'>Your Sony devices is compatible! Select your GlocalMe eSIM</p>
    <p><span>*</span>eSIM availability varies by country/region and carrier. Please contact your carrier or device manufacturer to confirm whether your Xperia device supports eSIM.</p>
        <p><span>*</span>Only the Sony Xperia 10 IV in Europe supports eSIM. Please contact your carrier or device manufacturer to confirm whether your Sony Xperia 10 IV supports eSIM.</p>
    `,
    tcl_warning: `
        <p class='title_warning'>Your Tcl devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM availability varies by country/region and carrier. Please contact your carrier or device manufacturer to confirm whether your device supports eSIM.</p>
    `,
    t_mobile_warning: `
        <p class='title_warning'>Your T-Mobile devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM availability varies by country/region and carrier. Please contact your carrier or device manufacturer to confirm whether your device supports eSIM.</p>
    `,
    xiaomi_warning: `
        <p class='title_warning'>Your XiaoMi devices is compatible! Select your GlocalMe eSIM</p>
        <p><span>*</span>eSIM availability varies by country/region and carrier. Please contact your carrier or device manufacturer to confirm whether your device supports eSIM.</p>
    `,
    other_warning: `
    <p class='title_warning'>Your devices is compatible! Select your GlocalMe eSIM</p>
    <p><span>*</span>Surface: Any device locked to AT&T does not support eSIM. If your device was purchased through another carrier, that carrier may have disabled eSIM functionality on Surface Duo.</p>
    `,

    windows_warning: `
    <p class='title_warning'>Your Windows devices is compatible! Select your GlocalMe eSIM</p>
    <p><span>*</span>For Windows 10: Your PC must be running Windows 10 version 1703 or later to use eSIM. The device must also support LTE.</p>
    
        <p><span>*</span>Surface: Any device locked to AT&T does not support eSIM. If your device was purchased through another carrier, that carrier may have disabled eSIM functionality on Surface Duo. Please contact your carrier for confirmation.</p>
    `,
    };

        
        
        
        
    function calcMaxDepth(node) {
    if (!node || typeof node !== 'object') return 0;
    if (node.__end === true) return 0;
    const keys = Object.keys(node).filter(k => !k.startsWith('__'));
    if (keys.length === 0) return 0;
    return 1 + Math.max(...keys.map(k => calcMaxDepth(node[k])));
    }

    /* ===== 计算当前路径的总步骤数 ===== */
    function getTotalSteps() {
    let cur = esim_data;
    for (let k of path) {
        if (cur[k] !== undefined) cur = cur[k];
    }
    return path.length + calcMaxDepth(cur);
    }

    const modal_json = document.getElementById("modal_json");
    const closeBtn_json = document.getElementById("closeBtn_json");
    const progressWrap = document.getElementById("progressWrap");
    const contentArea = document.getElementById("contentArea");

    let path = [];

    function getNode() {
    let node = esim_data;
    for (let k of path) node = node?.[k];
    return node;
    }

    function isEnd(node) {
    return node && node.__end === true;
    }

    function getEndText(node) {
    if (!node) return "";
    if (node.text) return node.text;
    if (node.textRef) return TEXT_TEMPLATES[node.textRef] || "";
    return "";
    }

    function sortKeys(obj) {
    return Object.keys(obj || {})
        .filter(k => !k.startsWith("__"))
        .sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase(), 'en', { sensitivity: 'base' }));
    }

    [
        "openBtn_json",
        "openBtn_json_mb",
        "ling_mb_top_click_eseim",
        "ling_pc_top_click_esim"
        ].forEach(id => {

        const openBtn = document.getElementById(id);

        if (openBtn) {
            openBtn.onclick = () => {
            modal_json.classList.remove("hidden");
            path = [];
            render();
            };
        }

    });

    closeBtn_json.onclick = () => modal_json.classList.add("hidden");

    modal_json.onclick = (e) => {
    if (e.target === modal_json) modal_json.classList.add("hidden");
    };

    function goBack() { path.pop(); render(); }
    function reset() { path = []; render(); }

    function render() {
    const current = getNode();

    /* ===== 进度条：动态步骤 ===== */
    progressWrap.innerHTML = "";

    const totalSteps = getTotalSteps();
    const currentStep = path.length;
    const percent = totalSteps > 0 ? Math.min(currentStep / totalSteps, 1) * 100 : 0;

    const bar = document.createElement("div");
    bar.className = "progress-bar_json";
    const inner = document.createElement("div");
    inner.className = "progress-inner_json";
    inner.style.width = percent + "%";
    bar.appendChild(inner);
    progressWrap.appendChild(bar);

    // 步骤点指示器
    if (totalSteps > 0) {
        const dotsWrap = document.createElement("div");
        dotsWrap.className = "progress-steps";
        for (let i = 0; i < totalSteps; i++) {
        const dot = document.createElement("div");
        dot.className = "step-dot";
        if (i < currentStep) dot.classList.add("done");
        else if (i === currentStep) dot.classList.add("current");
        dotsWrap.appendChild(dot);
        }
        const stepText = document.createElement("span");
        stepText.style.cssText = "font-size:12px;color:#666;margin-left:8px;line-height:8px;";
        stepText.textContent = isEnd(current)
        ? `Step ${totalSteps} / ${totalSteps}`
        : `Step ${currentStep} / ${totalSteps}`;
        dotsWrap.appendChild(stepText);
        progressWrap.appendChild(dotsWrap);
    }

    /* ===== 内容区 ===== */
    contentArea.innerHTML = "";

    const breadcrumb = document.createElement("div");
    breadcrumb.className = "breadcrumb_json";
    breadcrumb.textContent = path.length ? path.join(" > ") : "ROOT";
    contentArea.appendChild(breadcrumb);

    if (current?.__hint) {
        const hint = document.createElement("div");
        hint.className = "hint-box";
        hint.textContent = current.__hint;
        contentArea.appendChild(hint);
    }

    if (current?.__subtitle) {
        const sub = document.createElement("div");
        sub.className = "subtitle-box";
        sub.textContent = current.__subtitle;
        contentArea.appendChild(sub);
    }

    const mejson = document.createElement("div");
    mejson.id = "Mejson";
    contentArea.appendChild(mejson);

    if (isEnd(current)) {
        const end = document.createElement("div");
        end.className = "subtitle_all";
        end.innerHTML = getEndText(current);
        mejson.appendChild(end);
    } else {
        const keys = sortKeys(current);
        keys.forEach((k, index) => {
        const item = document.createElement("div");
        item.className = "tree-item";
        const keySpan = document.createElement("span");
        keySpan.className = "key";
        const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        keySpan.textContent = alphabet[index] || "#";
        const textSpan = document.createElement("span");
        textSpan.className = "text";
        textSpan.textContent = k;
        item.appendChild(keySpan);
        item.appendChild(textSpan);
        item.onclick = () => { path.push(k); render(); };
        mejson.appendChild(item);
        });
    }

    /* ===== 按钮 ===== */
    const btnWrap = document.createElement("div");
    btnWrap.className = "btn-wrap";

    const backBtn = document.createElement("button");
    backBtn.textContent = "Back";
    backBtn.disabled = path.length === 0;
    backBtn.onclick = goBack;
    btnWrap.appendChild(backBtn);

    if (isEnd(current)) {
        const rootBtn = document.createElement("button");
        rootBtn.textContent = "Back to list";
        rootBtn.onclick = reset;
        btnWrap.appendChild(rootBtn);
    }

    if (path.length > 0) {
        contentArea.appendChild(btnWrap);
    }
    }
    
